import { render, staticRenderFns } from "./budgetManagementDialog.vue?vue&type=template&id=06341b07&scoped=true"
import script from "./budgetManagementDialog.vue?vue&type=script&lang=js"
export * from "./budgetManagementDialog.vue?vue&type=script&lang=js"
import style0 from "./budgetManagementDialog.vue?vue&type=style&index=0&id=06341b07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06341b07",
  null
  
)

export default component.exports